import { React, useState } from 'react';
import PropTypes from 'prop-types';
import '../../styles/timeline.css';
import { useIntl, FormattedMessage } from 'react-intl';
import ConfirmationDialog from '../Parts/ConfirmationDialog';
import {
  ToolbarContainer,
  ExecuteBox,
  SelectBox,
  Button,
  SelectExecute,
} from './styles/ReportToolBarStyles';

// 新規アクションを実行する場合はここに追加
const ExecuteEvent = {
  delete: 'delete',
};

/**
 * 報告書一覧画面において、報告書削除などを実行するツールバー。
 *
 * @component
 * @param {Object} props
 * @param {Object} props.selectedReportIds - 選択された報告書IDの配列
 * @param {Function} props.onDataDeleteClick - 削除アクションをトリガーする関数
 */
const ReportToolBar = ({ selectedReportIds, onDataDeleteClick }) => {
  const { formatMessage } = useIntl();
  const [currentExecuteEvent, setCurrentExecuteEvent] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleExecuteEventChange = event => {
    setCurrentExecuteEvent(event.target.value);
  };

  const handleOpenDeleteDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDelete = () => {
    onDataDeleteClick();
    setIsDialogOpen(false);
  };

  return (
    <ToolbarContainer>
      <ExecuteBox>
        <FormattedMessage id="timeLine.timeLineToolBar.checked" />
        <SelectBox>
          <SelectExecute
            name="execute"
            id="execute-select"
            className="selected"
            value={currentExecuteEvent}
            onChange={handleExecuteEventChange}
          >
            <option value="">
              {formatMessage({
                id: 'timeLine.timeLineToolBar.select',
                defaultMessage: '選択してください',
              })}
            </option>
            <option value={ExecuteEvent.delete}>
              {formatMessage({
                id: 'timeLine.timeLineToolBar.delete',
                defaultMessage: '削除',
              })}
            </option>
          </SelectExecute>
        </SelectBox>
        <Button
          disabled={
            selectedReportIds.length === 0 || currentExecuteEvent === ''
          }
          onClick={
            selectedReportIds.length > 0 && currentExecuteEvent
              ? handleOpenDeleteDialog
              : undefined
          }
        >
          <FormattedMessage
            id="timeLine.timeLineToolBar.execute"
            defaultMessage="実行"
          />
        </Button>
      </ExecuteBox>
      {isDialogOpen && (
        <ConfirmationDialog
          headerText={
            <FormattedMessage
              id="userPrompt.report.header"
              defaultMessage="報告書削除"
            />
          }
          messageText={
            <FormattedMessage id="userPrompt.message.report.delete" />
          }
          onCancel={handleCloseDeleteDialog}
          onConfirm={handleDelete}
        />
      )}
    </ToolbarContainer>
  );
};

ReportToolBar.propTypes = {
  selectedReportIds: PropTypes.any.isRequired,
  onDataDeleteClick: PropTypes.func,
};

ReportToolBar.defaultProps = {
  onDataDeleteClick: () => {},
};

export default ReportToolBar;
